<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"440px"'
    :cpntTitulo="cpntTitulo"

    :cpntOnFecharDialog='buscaCadastroFechar'>
    <template slot='conteudo' v-if="Object.keys(formulario).length >= 1 && Object.keys(formulario.field).length >= 1">
      <div class="buscar-cadastro">
        <RF-Componente v-if="Object.keys(formulario.field.campo).length >= 1"
          :data-time='time'
          :cpntTamanho='formulario.field.campo.tamanho'
          :cpntModelo='formulario.field.campo.tipo'
          :cpntType='formulario.field.campo.type'
          :cpntStatus='formulario.field.campo.status'
          :cpntId='formulario.field.campo.id'
          :cpntClassDivField='formulario.field.campo.classDivField'
          :cpntNome='formulario.field.campo.nome'
          :cpntValue='formulario.field.campo.value'
          :cpntValueRef='formulario.field.campo.valueRef'
          :cpntAddButForm='formulario.field.campo.addButForm'
          :cpntOptions='formulario.field.campo.options'
          :cpntKeyValue='formulario.field.campo.keyValue'
          :cpntKeyMostra='formulario.field.campo.keyMostra'
          :cpntAutoComplete='formulario.field.campo.autocomplete'
          :cpntDisabled='formulario.field.campo.disabled'
          :cpntMostrar='formulario.field.campo.mostrar'
          :cpntMensagem='formulario.field.campo.mensagem'
          :cpntSelecioneNome='formulario.field.campo.selecioneNome'
          :cpntSelecioneValue='formulario.field.campo.selecioneValue'
          :cpntMensagemTipo='formulario.field.campo.mensagemTipo'
          :cpntAdicinarOption='formulario.field.campo.adicinarOption'
          :cpntMultiple='formulario.field.campo.multiple'
          :cpntAllRegistro='formulario.field.campo.allRegistro'
          :cpntExplica='formulario.field.campo.explica'
          :cpntConfig='formulario.field.campo.config'
          :cpntTabIndex='formulario.field.campo.tabIndex'
          :cpntMaxLength='formulario.field.campo.maxLength'
          :cpntOptionInicialNome='formulario.field.campo.optionInicialNome'
          :cpntOptionInicialValue='formulario.field.campo.optionInicialValue'

          :cpntRouter='formulario.field.campo.router'
          :cpntMethod='formulario.field.campo.method'
          :cpntField='formulario.field.campo.field'
          :cpntWhere='formulario.field.campo.where'

          :cpntOnChange='formulario.field.campo.onChange'
          :cpntOnBlur='formulario.field.campo.onBlur'
          :ref='formulario.field.campo.id'
        ></RF-Componente>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.buscar-cadastro {
  padding: 20px 0px 10px 0px;
}
  .buscar-cadastro > .rf-cpnt-group {
    margin: 0px auto;
    text-align: center;
  }
</style>

<style>
  .buscar-cadastro > .rf-cpnt-group > div > ul {
    position: fixed;
  }
</style>

<script>
  export default {
    props: {
      cpntTipo: {
        required: true,
        type: String
      },
      cpntTitulo: {
        required: true,
        type: String
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        formulario: {}
      }
    },
    mounted: function () {
      this.buscaCadastroIniciar()
    },
    methods: {
      buscaCadastroIniciar: function () {
        // SETA O STATUS DA TELA
        this.buscaCadastroSetarStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
        this.buscaCadastroFormularioIniciar()
      },
      buscaCadastroFechar: function (atualizar, id, dados) {
        // VERIFICA SE DEVE BUSCAR OS DADOS ATUALIZADOS NA API
        if (atualizar === true && [ '', null, undefined ].indexOf(dados) !== -1 && [ '', null, undefined ].indexOf(id) === -1 && [ '', null, undefined ].indexOf(this.cpntFecharFormulario) === -1) {
          var self = this

          // SETA O QUERY GET NA API
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id', o: '=', v: id } }

          // REALIZA A BUSCA DOS DADOS NA API
          self.$store.state.comunicaAPI(self.formulario.field.campo.router, self.formulario.field.campo.method, queryGet, function (apiSuccess) {
            self.buscaCadastroFechar(atualizar, id, apiSuccess.data[0])
          }, self.buscaCadastroSetarStatusGeral)
        } else {
          // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
          this.cpntFecharFormulario(atualizar, id, dados)
        }
      },
      buscaCadastroSetarStatusGeral: function (status) {
        // SETA O STATUS DA PAGINA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime() 
      },
      buscaCadastroFormularioIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'buscar-cadastro-' + self.cpntTipo + '--',
          field: {}
        }

        // SETA OS DADOS DA DIALOG
        self.formulario.field.campo = {
          tamanho: 50,
          id: self.formulario.id + 'campo',
          tipo: 'auto-complite',
          nome: 'Digite sua pesquisa',
          value: '',
          valueRef: '',
          addButForm: {
            id: self.formulario.id + 'campo--novo-cadastro',
            status: '',
            texto: '',
            class: [ 'btn', 'btn-primary', 'btn-sm' ],
            onClickButton: function (string) {
              // INICIA OS PARAMETROS
              var params = { tipo: self.cpntTipo, id: 0, nome: string }

              // SETA A FUNÇÃO CALLBACK
              params.callback = self.buscaCadastroFechar

              // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
              self.$store.commit('SET_ABRIR_CADASTRO_VET', params)
            }
          },
          onChange: self.buscaCadastroFormularioOnChange
        }

        switch (self.cpntTipo) {
          case 'contato':
            // SETA OS DADOS PARA O AUTO COMPLITE
            self.formulario.field.campo.router = '/contato/get'
            self.formulario.field.campo.method = 'POST'
            self.formulario.field.campo.field = { id: null, nome: null, empresa: null, cnpj_cpf: null }
            self.formulario.field.campo.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'contato', o: 's.ft', v: '' } ] }
            self.formulario.field.campo.keyMostra = [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ]

            // SETA O TITULO DO BOTÃO
            self.formulario.field.campo.addButForm.texto = 'Adicionar novo contato'
            break

          default:
            self.buscaCadastroSetarStatusGeral({ loc: 'WEB', cod: '500', err: 'Tipo de cadastro (' + self.cpntTipo + ') não encontrado.' })
            break
        }

        // REALIZA O FOCUS NO CAMPO SOLICITADO
        self.buscaCadastroFormularioCamposFocus(self.formulario.field.campo.id)

        // SETA O STATUS DA TELA
        self.buscaCadastroSetarStatusGeral('')
      },
      buscaCadastroFormularioOnChange: function (value, id) {
        // PEGA O CAMPO QUE DEVE SER ATUALIZADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.formulario.field[index[1]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index[1]].mensagem = ''
        this.formulario.field[index[1]].mensagemTipo = ''

        // SETA O VALOR RECEBIDO
        switch (this.cpntTipo + '--' + index[1]) {
          case 'contato--campo':
            this.formulario.field[index[1]].value = value.nome
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE FAZER ALGUMA AÇÃO NO CAMPO
        switch (index[1]) {
          case 'campo':
            this.buscaCadastroFechar(true, value.id)
            break
        }
      },
      buscaCadastroFormularioCamposFocus: function (campo, tentativa = 0, self = null) {
        if (tentativa <= 10) {
          // SETA O VALOR PARA INICIAR A VARIAVEL
          if (self === null) {
            self = this
          }
  
          if ([ '', null, undefined ].indexOf(self.$refs[campo]) === -1 && Object.keys(self.$refs[campo].$refs).length >= 1 && [ '', null, undefined ].indexOf(self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField) === -1) {
            self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField()
          } else {
            setTimeout(function () { self.buscaCadastroFormularioCamposFocus(campo, (tentativa + 1), self) }, 500)
          }
        }
      },
    }
  }
</script>
